/*
 * An object containing properties for filter types
 */
var FilterType = /** @class */ (function () {
    function FilterType() {
    }
    /**
     * Select type
     */
    FilterType.SELECT = 'select';
    /**
     * Text type
     */
    FilterType.TEXT = 'text';
    /**
     * Type ahead type
     */
    FilterType.TYPEAHEAD = 'typeahead';
    return FilterType;
}());
export { FilterType };
//# sourceMappingURL=filter-type.js.map